import { render, staticRenderFns } from "./SlicesBlock.vue?vue&type=template&id=6c0207b3&"
import script from "./SlicesBlock.vue?vue&type=script&lang=js&"
export * from "./SlicesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports